import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApilistService } from '../services/apilist.service';
import { CommonService } from '../services/common.service';
import { GlobalService } from '../services/global.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-materialsubscription',
  standalone: true,
  imports: [
    CommonModule, // ✅ for *ngIf, *ngFor, ngStyle
    FormsModule, // ✅ for [(ngModel)]
    ReactiveFormsModule, // ✅ for reactive forms
  ],
  templateUrl: './materialsubscription.component.html',
  styleUrls: ['./materialsubscription.component.scss'],
})
export class MaterialsubscriptionComponent implements OnInit {
  [x: string]: any;

  display: any = 'none';
  displayDelete: any = 'none';
  subjectName: any;
  year: any;
  category: any;
  cources: any[];
  courseData: any;
  showAdd = false;
  showEdit = false;
  materialdata: any[];
  subjectDetails;
  subEdit = false;
  id: any;

  courseForm: UntypedFormGroup;

  showErr = false;
  deleteErr: any;

  searchval: any;

  error_messages = {
    subjectval: [{ type: 'required', message: 'Please enter Subject' }],
    yearval: [{ type: 'required', message: 'Please enter Year' }],
    categorytypeval: [{ type: 'required', message: 'Please Select Category' }],
  };
  adminName: any;
  adminImage: any;
  allSubscription: any;
  allData: any;

  showData = false;
  showNodata = false;

  @ViewChild('boxCourse', { static: false }) boxCourse: ElementRef;

  constructor(
    public utils: ApilistService,
    public commonservice: CommonService,
    public globalService: GlobalService,
    public formBuilder: UntypedFormBuilder,
    private spinner: NgxSpinnerService
  ) {
    this.courseForm = this.formBuilder.group({
      subjectval: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
      yearval: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
      categorytypeval: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
    });

    let admin = JSON.parse(localStorage.getItem('adminDetails'));
    let adminData = JSON.parse(admin);

    this.adminName = adminData[0].name;
    this.adminImage = adminData[0].image;

    if (this.adminImage == null || this.adminImage == undefined) {
      this.adminImage = 'assets/tenant-avatar.jpg';
    }
  }

  editsubscription(sub) {
    this.subEdit = !this.subEdit;
    console.log('payload', sub);
  }

  updatematerialsubscription(sub) {
    this.spinner.show();
    let payload = {
      id: sub.id,
      subscription_days: sub.subscription_days,
      price: sub.price,
    };
    console.log('payload-----', payload);
    const servicePath = this.utils.getApiConfigs('materialsubscription');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          // console.log(resp);
          this.globalService.showSuccess('Subject added Successfully');
          this.display = 'none';
          this.ngOnInit();
          this.courseForm.reset();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
          this.display = 'none';
          // console.log("data", resp.data);
        }
      });
  }

  deletematerialcategorysubcription(id) {
    this.spinner.show();
    let payload = {
      id: id,
    };
    const servicePath = this.utils.getApiConfigs(
      'materialcatergorysubscription'
    );
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          this.globalService.showSuccess('Subcription Delete Successfully');
          this.display = 'none';
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
        }
      });
  }

  ngOnInit(): void {
    this.spinner.show();

    this.courseForm.reset();

    this.getmaterialcategory();
    this.getmaterialsubscription();
  }

  onMouseOver(e) {
    (<HTMLDivElement>this.boxCourse.nativeElement).style.pointerEvents = 'auto';
    (<HTMLDivElement>this.boxCourse.nativeElement).style.cursor = 'pointer';
  }

  onChangeEvent(event) {
    // console.log("event", event);

    var val = event.target.value;
    // console.log("val", this.category);

    this.allData = this.subscriptiondetail;

    // console.log("All Data", this.allData);

    if (val) {
      this.allSubscription = this.allData.filter((item) =>
        item.category.toLowerCase().includes(val.toLowerCase())
      );
    }

    // console.log("Courses Data", this.allCourse);
    if (this.allSubscription == '') {
      this.globalService.showError('No data found');
    }
  }

  reset() {
    this.ngOnInit();
    this.searchval = '';
  }

  addSubject1() {
    this.spinner.show();
    let payload = {
      material_cat_id: this.category,
      subscription_days: this.days,
      price: this.price,
    };
    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('materialsubscription');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          // console.log(resp);
          this.globalService.showSuccess('Subject added Successfully');
          this.display = 'none';
          this.ngOnInit();
          this.courseForm.reset();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
          this.display = 'none';
          // console.log("data", resp.data);
        }
      });
  }

  openAdd() {
    this.courseForm.reset();
    this.display = 'block';
    this.showAdd = true;
    this.showEdit = false;
  }

  // editCourse(data){
  //   // console.log("Data", data);
  //   this.display = "block";
  //   this.showAdd = false;
  //   this.showEdit = true;

  //   this.courseName = data.courses;
  //   this.id = data.id;
  // }

  deleteCourse(data) {
    this.displayDelete = 'block';
    this.deleteErr = '';
    this.id = data.id;
  }

  getmaterialcategory() {
    this.spinner.show();

    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('getcategory');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, '')
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          this.materialdata = resp.data;
          console.log('----------------------', this.materialdata);
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
          // console.log("data", resp.data);
        }
      });
  }

  getmaterialsubscription() {
    this.spinner.show();
    const servicePath = this.utils.getApiConfigs('allmaterialsubscription');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, '')
      .then((resp: any) => {
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          this.subscriptiondetail = resp.data;
          console.log('sasdsd', this.subscriptiondetail);

          // console.log("course details", JSON.stringify(this.courseDetails));

          if (this.subscriptiondetail == '') {
            this.showNodata = true;
            this.showData = false;
          } else {
            this.showData = true;
            this.showNodata = false;
          }
        }

        this.allSubscription = this.subscriptiondetail;
        console.log('Alls', this.allSubscription);
      });
  }

  // updateCourse(){
  //   this.spinner.show();
  //   let payload = {
  //     "courses": this.courseName,
  //     "id": this.id
  //   }
  //   // console.log("payload", payload);
  //   const servicePath = this.utils.getApiConfigs('course');
  //   this.commonservice.invokeService(servicePath[0].method, servicePath[0].path, payload)
  //     .then((resp: any) => {
  //       // console.log("resp", resp);
  //       this.spinner.hide();
  //       if (resp.status_code == "200") {
  //         this.spinner.hide();
  //         // console.log(resp);
  //         this.globalService.showSuccess("Course updated successfully");
  //         this.display = "none";
  //         this.ngOnInit();
  //         this.courseForm.reset();
  //       }else if(resp.status_code == "400"){
  //         this.spinner.hide();
  //         // console.log("data", resp.data);
  //         this.globalService.showError(resp.data);
  //         this.display = "none";
  //       }
  //     });
  // }

  onCloseHandled() {
    this.display = 'none';
    this.displayDelete = 'none';
  }

  delete() {
    this.spinner.show();
    let payload = {
      id: this.id,
    };
    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('deletecourses');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          // console.log(resp);
          this.globalService.showSuccess('Course deleted successfully');
          this.displayDelete = 'none';
          this.ngOnInit();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          // console.log("data", resp.data);
          this.showErr = true;
          this.deleteErr = resp.message;
        }
      });
  }
}
